import type { ExternalReviewSettings } from 'api/ExternalReviewSettings'

import { FeatureName, localStorageFeatureToggle } from './feature-toggle-utils'

export type PreviewVariant = 'legacy' | 'uplift'

type PreviewVariantSettings = Partial<ExternalReviewSettings> & {
  postPreviewV2?: boolean
  previewVariant?: PreviewVariant
}

export const resolvePostPreviewVariant = (
  settings?: PreviewVariantSettings,
  href = typeof window === 'undefined' ? '' : window.location.href
): PreviewVariant => {
  const urlOverride = getPreviewV2UrlOverride(href)

  if (urlOverride !== undefined) {
    return urlOverride ? 'uplift' : 'legacy'
  }

  if (localStorageFeatureToggle.get(FeatureName.PostPreviewV2)) {
    return 'uplift'
  }

  if (settings?.previewVariant === 'uplift') {
    return 'uplift'
  }

  if (settings?.previewVariant === 'legacy') {
    return 'legacy'
  }

  return settings?.postPreviewV2 ? 'uplift' : 'legacy'
}

export const getPreviewV2UrlOverride = (href: string): boolean | undefined => {
  if (!href) {
    return undefined
  }

  try {
    const url = new URL(href)
    const searchOverride = parsePreviewV2Param(url.searchParams)

    if (searchOverride !== undefined) {
      return searchOverride
    }

    return parsePreviewV2HashParam(url.hash)
  } catch {
    return parsePreviewV2HashParam(href)
  }
}

const parsePreviewV2HashParam = (hash: string): boolean | undefined => {
  if (!hash) {
    return undefined
  }

  const queryStart = hash.indexOf('?')
  if (queryStart >= 0) {
    return parsePreviewV2Param(new URLSearchParams(hash.slice(queryStart + 1)))
  }

  const ampersandStart = hash.indexOf('&')
  if (ampersandStart >= 0) {
    return parsePreviewV2Param(
      new URLSearchParams(hash.slice(ampersandStart + 1))
    )
  }

  return undefined
}

const parsePreviewV2Param = (params: URLSearchParams): boolean | undefined => {
  if (!params.has('previewV2')) {
    return undefined
  }

  const value = params.get('previewV2')?.toLowerCase()

  if (value === '0' || value === 'false' || value === 'legacy') {
    return false
  }

  return true
}
